import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { userSortOptions } from '../../data/userSortOptions';
import type { UserSort } from '../../types/voip';
interface SortSelectProps {
  value: UserSort;
  onChange: (sort: UserSort) => void;
}
export function SortSelect({
  value,
  onChange
}: SortSelectProps) {
  return <label className="relative inline-flex" data-id="element-652" data-mp="2ew30i750lits">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[13px] text-muted" data-id="element-653" data-mp="1i73w537jx16v">Sort by:</span>
      <select value={value} onChange={e => onChange(e.target.value as UserSort)} aria-label="Sort users by" className="appearance-none rounded-xl border border-line bg-surface py-2 pl-[68px] pr-9 text-[13px] font-medium text-ink shadow-card transition-colors duration-150 ease-out hover:border-accent/30 focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/15" data-id="element-654" data-mp="1m876592x4306">
        {userSortOptions.map(o => <option key={o.value} value={o.value} data-id="element-655" data-mp="13fuxk4lo85hl">
            {o.label}
          </option>)}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-subtle" aria-hidden data-id="element-656" data-mp="2c29k9pv8ezr4" />
    </label>;
}